import React from 'react'
import logo from "../images/logo.png"
import fb from "../icons/fb.png"
import what from "../icons/what.png"
import x from "../icons/x.png"
import insta from "../icons/insta.png"
import pause from "../icons/pause.png"

const Footer = () => {
  return (
    <footer className='color-brimary pt-5 pb-5'>
            
    <div className='container mt-5'>
      <div className='row'>
       <div className='col-lg-3'>
        <img src={logo} alt='' />
        <div className='d-flex'>
        <img src={fb} alt='' />
        <img src={what} alt='' />
        <img src={x} alt='' />
        <img src={insta} alt='' />

        </div>
       </div>
       <div className='col-lg-3'>
        <h6>Company</h6>
        <p>Our Team</p>
        <p>Pricing</p>
        <p>Services</p>
        <p>About Us</p>
        <p>Contact Us</p>
       </div>
       <div className='col-lg-3'>
       <h6>Contact</h6>
        <p>562 A, M G Road, Chatri Wala Kuan, Lado Sarai, New Delhi, Delhi 110030</p>
        <p>Phone No: +9195608 56999</p>
        <p>Email : info@ahaanfurniturestudio.com</p>
       </div>
       <div className='col-lg-3'>
        <h5>Get the latest information</h5>
        <div className='footer-form d-flex'>
            <input type="email"  placeholder='Enter your email '/>
            <button><img src={pause} alt=''/></button>
        </div>
       </div>
      </div>
    </div>
    </footer>

  )
}

export default Footer
